/* eslint-disable react/prop-types */
import React, { ReactNode } from 'react';
import { Link } from '@cambridgeassessment/cambridge-ui';
import { StyledGridItem, StyledGridItemDescription } from './GridItem.styles';

interface Props {
  title: string;
  children: ReactNode;
  path: string;
  qaId: string;
}

const GridItem: React.FC<Props> = ({ title, children, path, qaId }) => (
  <StyledGridItem container item xs={12} md={6} data-qa-id={qaId}>
    <Link router path={path} dataQaId={`${qaId}-link`} title={title} />
    <StyledGridItemDescription>{children}</StyledGridItemDescription>
  </StyledGridItem>
);

export default GridItem;
